<template>
  <v-card>
    <v-card flat>
      <v-layout row wrap>
        <v-flex xs12 md7 lg7>
          <v-layout row wrap pb-2>
            <v-flex xs12>
              <v-card-title class="grey lighten-4 pa-2 mb-4">
                <h3>Interactive Controller</h3>
                <v-spacer></v-spacer>
              </v-card-title>
              <v-card-actions >

                <v-btn
                  small
                  color="success"
                  outline
                  class="ml-2"
                  @click.stop="isChatOpen=!isChatOpen"
                  >Send Notifications</v-btn
                >
                <v-btn
                  v-if="
                    streams[DEFINES.LiveChat] &&
                    streams[DEFINES.LiveChat].active
                  "
                  small
                  color="red"
                  outline
                  @click.stop="deactivate(streams[DEFINES.LiveChat])"
                  >Disable Chat</v-btn
                >
                <v-btn
                  v-else
                  small
                  color="success"
                  outline
                  @click.stop="enableLiveChat()"
                  >Enable Chat</v-btn
                >
              </v-card-actions>
            </v-flex>
            <v-flex xs12 md12 sm12 lg12 pl-3 pr-3 pd-3 pt-2>
              <v-card-title class="grey lighten-4 pa-2">
                <h4>Active streams</h4>
                <v-spacer></v-spacer>
              </v-card-title>
              <div v-if="active_streams && active_streams.length">
                <v-layout row wrap>
                  <v-flex  v-for="stream in active_streams"
                    :key="stream.stream_id"
                    xs12 sm12 md3 pa-2>
                    <v-card
                      hover
                      @click.prevent="openConfigDialogWith(stream)"
                    >
                      <v-card-actions>
                        <v-tooltip slot="append" top color="white">
                          <v-btn
                            slot="activator"
                            small
                            color="red"
                            icon
                            outline
                            @click.stop="deactivate(stream)"
                          >
                            <v-icon>stop</v-icon>
                          </v-btn>
                          <span class="greyDarken3--text body-1">
                            Remove Stream
                          </span>
                        </v-tooltip>

                        <v-spacer></v-spacer>
                        <span v-if="stream.force" class="blink text-lg-right text-md-right">
                          <v-icon class="blink" color="red"
                            >$vuetify.icons.rms_live</v-icon
                          >
                        </span>
                      </v-card-actions>
                      <v-card-text class="pa-3">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-img
                              v-if="
                                selected_company_id == 60 &&
                                stream.stream_id == 4
                              "
                              height="100"
                              contain
                              :src="
                                require('@/assets/temp-live-tv-hardcoded.png')
                              "
                            ></v-img>
                            <v-img
                              v-else
                              height="60"
                              contain
                              :src="
                                require('@/assets/' +
                                  DEFINES.streams_properties[
                                    stream.stream_id
                                  ].logo_name)
                              "
                            ></v-img>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </div>
              <div v-else>
                <v-card flat class="pa-2">
                  <v-container fluid fill-height>
                    <v-layout align-center justify-center>
                      <v-flex>
                        <div class="text-lg-center">
                          <span class="grey--text title"
                            >{{ $t("screener.stream.no_live_stream.message") }}
                          </span>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </div>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row wrap pb-2>
            <v-flex xs12 md12 sm12 lg12 pl-3 pr-3 pd-3 pt-2>
              <v-card-title class="grey lighten-4 pa-2">
                <h4>
                  {{ $t("screener.stream.available_to_use") }}
                </h4>
                <!-- <v-spacer></v-spacer>
                <v-btn small color="error" @click="enforceMovie()">{{
                  $t("stream.enforce_movie.btn")
                }}</v-btn> -->
              </v-card-title>
              <v-spacer></v-spacer>
              <!-- <v-btn color="error" @click="enforceMovie()">{{
                  $t("stream.enforce_movie.btn")
                }}</v-btn> -->

              <div v-if="available_to_use.length">
                <v-layout row wrap>
                  <v-flex
                    v-for="stream in available_to_use"
                    :key="stream.stream_id"
                    xs12
                    sm12
                    md3
                    pa-2
                  >
                    <v-card
                      hover
                      @click="openConfigDialogWith(stream)"
                      class="pa-3"
                    >
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-img
                            v-if="
                              selected_company_id == 60 && stream.stream_id == 4
                            "
                            height="100"
                            contain
                            :src="
                              require('@/assets/temp-live-tv-hardcoded.png')
                            "
                          ></v-img>
                          <v-img
                            v-else
                            height="100"
                            contain
                            :src="
                              require('@/assets/' +
                                DEFINES.streams_properties[stream.stream_id]
                                  .logo_name)
                            "
                          ></v-img>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </div>
              <div v-else>
                <v-card class="pa-2">
                  <v-container fluid fill-height>
                    <v-layout align-center justify-center>
                      <v-flex>
                        <div class="text-lg-center">
                          <span class="grey--text title">{{
                            $t("screener.stream.not_configured.message")
                          }}</span>
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </div>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout row wrap>
            <v-flex xs12 md12 sm12 lg12 pl-3 pr-3 pd-3 pt-2>
              <v-card-title class="grey lighten-4 pa-2">
                <h4>
                  {{ $t("screener.stream.not_configured_streams") }}
                </h4>
                <v-spacer></v-spacer>
              </v-card-title>
              <v-layout row wrap>
                <v-flex
                  v-for="stream in not_configured_streams"
                  :key="stream.stream_id"
                  xs12
                  sm12
                  md3
                  pa-2
                >
                  <v-card
                    hover
                    @click="openConfigDialogWith(stream)"
                    class="pa-3"
                  >
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-img
                          v-if="
                            selected_company_id == 60 && stream.stream_id == 4
                          "
                          height="100"
                          contain
                          :src="require('@/assets/temp-live-tv-hardcoded.png')"
                        ></v-img>
                        <v-img
                          v-else
                          height="100"
                          contain
                          :src="
                            require('@/assets/' +
                              DEFINES.streams_properties[stream.stream_id]
                                .logo_name)
                          "
                        ></v-img>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md5 lg5  class="preview-section">
          <div v-if="lastUpdate.by" class="grey lighten-4 error--text text-xs-center">Last updated by: {{lastUpdate.by}} - {{utcToTz(lastUpdate.time,timezone)}}</div>
          <v-container fill-height class="grey lighten-4">
            <v-layout row wrap justify-space-between>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex
                    :xs10="fb_active_streams.length"
                    :xs12="!fb_active_streams.length"
                  >
                    <h3 class="text-xs-center pb-1">
                      Live Preview
                      <!-- <v-tooltip top color="white">
                        <template v-slot:activator="{ on }">
                          <v-icon size="19" v-on="on">mdi-information-outline</v-icon>
                        </template>
                        <span class="greyDarken3--text body-1">
                          Identical to users
                        </span>
                      </v-tooltip> -->
                    </h3>
                    <v-card class="mx-auto">
                      <v-card>
                        <v-img
                          :src="
                            screener.thumbnail_url
                              ? screener.thumbnail_url
                              : screener.films[0]
                              ? screener.films[0].thumburls
                              : ''
                          "
                          gradient="to top, rgba(0,0,0,.44), rgba(0,0,0,.44)"
                          min-height="350px"
                          max-height="350px"
                          contain
                        >
                          <v-container fill-height>
                            <v-layout v-if="fb_forced_stream" align-center>
                              <v-card
                                :dark="false"
                                class="pa-0"
                                width="100%"
                                height="100%"
                              >
                                <v-container fill-height>
                                  <v-layout align-center>
                                    <v-flex xs12>
                                      <v-img
                                        height="100px"
                                        contain
                                        :src="
                                          require('@/assets/' +
                                            DEFINES.streams_properties[
                                              fb_forced_stream.stream_id
                                            ].logo_name)
                                        "
                                      ></v-img>
                                    </v-flex>
                                  </v-layout>
                                </v-container>
                              </v-card>
                            </v-layout>
                          </v-container>
                        </v-img>
                      </v-card>
                    </v-card>
                  </v-flex>
                  <v-flex v-if="fb_active_streams.length" xs2>
                    <v-layout row wrap class="mt-4 ml-2">
                      <v-flex
                        v-for="stream in fb_active_streams"
                        :key="stream.stream_id"
                        xs12
                      >
                        <v-card hover height="50px" flat>
                          <v-card-text class="pa-1">
                            <v-img
                              height="50"
                              contain
                              :src="
                                require('@/assets/' +
                                  DEFINES.streams_properties[stream.stream_id]
                                    .logo_name)
                              "
                            ></v-img>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="snackbar.isVisible">
                <v-snackbar
                  v-model="snackbar.isVisible"
                  color="success"
                  :timeout="5000"
                >
                  {{ snackbar.message }}
                  <v-btn
                    dark
                    flat
                    @click="snackbar.isVisible = false"
                  >
                    Close
                  </v-btn>
                </v-snackbar>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="subheadline pb-2 font-weight-black">
                      {{ $t("screener.stream.overview") }}
                    </div>
                    <v-layout row wrap>
                      <v-flex xs12 md6 lg6 pt-4 pr-4 pd-4>
                        <v-card class="pa-4">
                          <div class="subheading text-xs-center">
                            <span
                              class="green--text subheading font-weight-bold"
                              v-if="fb_forced_stream"
                              >{{
                                DEFINES.streams_properties[
                                  fb_forced_stream.stream_id
                                ].name
                              }}</span
                            >
                            <span class="green--text subheading font-weight-thin" v-else>{{
                              $t("screener.stream.movie.default")
                            }}</span>
                          </div>
                          <div
                            class="
                              subheading
                              red--text
                              text--darken-3
                              font-weight-thin
                              text-xs-center
                            "
                          >
                            {{ $t("screener.stream.forced_stream") }}
                          </div>
                        </v-card>
                      </v-flex>
                      <v-flex xs12 md6 lg6 pt-4 pr-4 pd-4>
                        <v-card class="pa-4 text-center">
                          <div class="text-xs-center headline">
                            {{ liveUsers }}
                          </div>
                          <div
                            class="
                              subheading
                              red--text
                              text--darken-3
                              font-weight-thin
                              text-xs-center
                            "
                          >
                            {{ $t("screener.admin.live_counter") }}
                          </div>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </v-card>
    <v-divider></v-divider>
    <!-- <v-layout row wrap pb-5>
      <v-flex xs12 md12 sm12 lg12 pl-3 pr-3 pd-3 pt-2>
        <div class="subheadline pb-2 font-weight-black">
          Overview
        </div>
        <v-card>
          <v-layout row wrap>
            <v-flex xs12 sm12 md4 pa-2>
              <v-card flat class="pa-3">
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="headline text-xs-center">Movie</div>
                    <div class="caption saSecondary--text text-xs-center">
                     Current stream
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 sm12 md4 pa-2>
              <v-card flat class="pa-3">
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="headline text-xs-center">3</div>
                    <div class="caption saSecondary--text text-xs-center">
                      Available streams
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 sm12 md4 pa-2>
              <v-card flat class="pa-3">
                <v-layout row wrap>
                  <v-flex xs12>
                    <div class="headline text-xs-center">Enabled</div>
                    <div class="caption saSecondary--text text-xs-center">
                      Live chat status
                    </div>
                  </v-flex>
                </v-layout>
              </v-card></v-flex
            >
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout> -->
    <iframe :src="setCookieUrl" v-show="false"></iframe>
    <!-- <EnforceMovie
      :streams="streams"
      :screener_id="screener_id"
      @removeForceStream="_removeForceFromOtherStream"
    />
    <v-form ref="form">
      <template>
        <div v-for="stream in streams" :key="stream.type">
          <v-card-title class="grey lighten-4">
            <h3 class="secondary--text">
              {{ $t("screener.stream.title." + stream.type) }}
              <b v-if="stream.force && stream.active" class="primary--text"
                >(Forced)</b
              >
            </h3>
            <v-spacer></v-spacer>

            <v-btn
              v-if="!stream.active"
              color="error"
              outline
              small
              @click="broadcast(stream)"
              >{{ $t("screener.save.form.stream.live_on_air") }}</v-btn
            >

            <v-btn
              v-if="!stream.active && stream.type != DEFINES.LiveChat"
              color="error"
              outline
              small
              @click="confirmForceStream(stream)"
            >
              <b>{{ $t("screener.save.form.stream.force_live_on_air") }}</b>
            </v-btn>

            <v-btn
              v-if="stream.active"
              outline
              small
              @click="deactivate(stream)"
              >{{ $t("screener.save.form.stream.live_stop") }}</v-btn
            >

            <v-btn color="success" outline small @click="showPreview(stream)">{{
              $t("rms.button.media_editor.preview")
            }}</v-btn>
            <DownloadMsgs v-if="stream.type == DEFINES.LiveChat" />
            <v-divider vertical class="mx-1"></v-divider>

            <v-btn color="secondary" small @click="saveStreams">{{
              $t("rms.button.save")
            }}</v-btn>
          </v-card-title>
          <v-card-text v-if="stream.type != DEFINES.VimeoLiveStream">
            <ul
              class="greyDarken2--text px-3"
              v-if="stream.type == DEFINES.ZoomMeeting"
            >
              <li>{{ $t("screener.stream.zoom.inst_1") }}</li>
              <li>{{ $t("screener.stream.zoom.inst_2") }}</li>
              <li>{{ $t("screener.stream.zoom.inst_3") }}</li>
            </ul>
            <ul
              class="greyDarken2--text px-3"
              v-if="stream.type == DEFINES.VimeoChatStream"
            >
              <li>{{ $t("screener.stream.vimeo_chat.inst_1") }}</li>
              <li>{{ $t("screener.stream.vimeo_chat.inst_2") }}</li>
            </ul>
            <ul
              class="greyDarken2--text px-3"
              v-if="stream.type == DEFINES.LiveChat"
            >
              <li>{{ $t("screener.stream.live_chat.inst_1") }}</li>
            </ul>
          </v-card-text>
          <v-card-text>
            <v-text-field
              id="stream_title"
              :label="$t('screener.save.form.stream.title')"
              name="stream_title"
              color="primary"
              type="text"
              v-model="stream.title"
            ></v-text-field>
            <v-text-field
              v-if="DEFINES.VimeoStreams.includes(stream.type)"
              id="stream_content"
              :label="$t('screener.save.form.stream_content')"
              name="stream_content"
              color="primary"
              type="text"
              v-model="stream.vimeo_live_id"
              :placeholder="$t('screener.save.stream_content.placeholder')"
            ></v-text-field>
            <v-text-field
              v-if="stream.type == DEFINES.FacebookLiveStream"
              id="stream_content"
              :label="$t('screener.save.form.facebook.stream_content')"
              name="stream_content"
              color="primary"
              v-model="stream.content"
              type="text"
            ></v-text-field>
            <v-text-field
              v-if="stream.type == DEFINES.YoutubeLiveStream"
              id="stream_content"
              :label="$t('screener.save.form.youtube.stream_content')"
              name="stream_content"
              color="primary"
              v-model="stream.content"
              type="text"
            ></v-text-field>
            <template v-if="stream.type == DEFINES.ZoomMeeting">
              <v-text-field
                id="stream_title"
                :label="$t('screener.save.form.stream.meeting_number')"
                name="stream_title"
                color="primary"
                :hint="$t('screener.save.form.zoom_meeting_no.no_space')"
                type="text"
                v-model="stream.meeting_number"
                @input="trimSpace"
              ></v-text-field>
              <v-text-field
                id="stream_title"
                :label="$t('screener.save.form.stream.meeting_password')"
                name="stream_title"
                color="primary"
                type="text"
                v-model="stream.meeting_password"
              ></v-text-field>
            </template>
          </v-card-text>
        </div>
      </template>
    </v-form> -->
    <NotificationsChat :isChatOpen.sync="isChatOpen" />
    <ConfirmationDialog
      v-if="dialog"
      :dialog="dialog"
      :text="$t('screener.force_stream_info')"
      @confirm="broadcast(forceStream, true)"
      @cancel="dialog = false"
    ></ConfirmationDialog>
    <StreamConfigurationDialog
      :dialog.sync="configurationDialog.dialog"
      :currentStream.sync="currentConfiguringStream"
      @broadcast="broadcast"
      @confirmForceStream="confirmForceStream"
      @deactivate="deactivate"
      @showPreview="showPreview"
      @saveStreams="saveStreams"
      @enableLiveChat="enableLiveChat"
    >
    </StreamConfigurationDialog>
    <v-dialog
      v-if="preview"
      v-model="preview"
      :width="is_live_chat_preview ? 800 : 640"
    >
      <v-img
        v-if="is_live_chat_preview"
        src="@/assets/livechat_preview.png"
      ></v-img>
      <iframe
        v-else
        allow="microphone; camera"
        :src="previewStream"
        muted
        width="100%"
        height="400"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </v-dialog>
  </v-card>
</template>
<script>
import ConfirmationDialog from "@/components/dialogBox/Confirmation";
import rules from "@/validation";
import { mapGetters } from "vuex";
import {
  getZoomUrl,
  getVimeoEmbedUrl,
  getVimeoChatEmbedUrl,
  getFacebookLiveEmbedUrl,
  getYoutubeLiveEmbedUrl,
} from "@/helper";
import { getSetCookieUrl } from "@/api/_manager";
import NotificationsChat from "@/components/screener/NotificationsChat";
import DownloadMsgs from "@/components/screener/DownloadMsgs";
import EnforceMovie from "@/components/screener/EnforceMovie";
import DEFINES from "@/defines";
import StreamConfigurationDialog from "./StreamConfigurationDialog.vue";
import moment from 'moment';
import { utcToTz, tzToUtc } from "@/helper";
export default {
  name: "ScreenerStreams",
  props: ["screener_id", "screener"],
  data() {
    return {
      rules,
      moment,
      preview: false,
      is_live_chat_preview: false,
      previewStream: null,
      forceStream: null,
      dialog: false,
      streams: this.DEFINES.streams,
      setCookieUrl: getSetCookieUrl(),
      configurationDialog: {
        dialog: false,
        currentStream: null,
      },
      currentConfiguringStream: null,
      fb_forced_stream: null,
      fb_active_streams: [],
      liveUsers: 0,
      snackbar: {
        isVisible: false,
        message: null
      },
      isChatOpen: false,
      lastUpdate: {
        by: null,
        time: null
      },
      utcToTz,
      discontinuedStreams:[DEFINES.ZoomMeeting, DEFINES.JitsiLiveStream]
    };
  },
  computed: {
    ...mapGetters("company", {
      selected_company_id: "getSelected",
      timezone: "getSelectedCompanyTimezone",
    }),
    active_streams() {
      let streams = [];
      for (var key in this.streams) {
        if (this.streams[key].active || this.streams[key].force) {
          streams.push(this.streams[key]);
        }
      }
      return streams;
    },
    available_to_use() {
      let streams = [];
      for (var key in this.streams) {
        var isConfigured = this.validateStream(this.streams[key]);
        if (isConfigured && !this.streams[key].active) {
          streams.push(this.streams[key]);
        }
      }
      return streams;
    },
    forced_stream() {
      let forced_stream = null;
      for (var key in this.streams) {
        if (this.streams[key].force && this.streams[key].active) {
          forced_stream = this.streams[key];
        }
      }
      return forced_stream;
    },
    not_configured_streams() {
      let not_configured_streams = [];
      for (var key in this.streams) {
        var isConfigured = this.validateStream(this.streams[key]);
        if (!isConfigured) {
          not_configured_streams.push(this.streams[key]);
        }
      }
      return not_configured_streams;
    },
  },

  components: {
    ConfirmationDialog,
    NotificationsChat,
    DownloadMsgs,
    EnforceMovie,
    StreamConfigurationDialog,
  },
  created() {
    this.getStreams();
  },
  mounted() {
    this.bindScreenerWithFB();
    this.bindLiveCounterWithFBase();
    this.bindScreenerNotificationsWithFB();
  },
  methods: {
    trimSpace(value) {
      this.streams[this.DEFINES.ZoomMeeting].meeting_number = value.replace(
        /\s/g,
        ""
      );
    },

    confirmForceStream(stream) {
      if (!this.validateStream(stream)) {
        return false;
      }
      this.forceStream = stream;
      this.dialog = true;
    },

    async getStreams() {
      try {
        if (this.$route.params.screener_id == undefined) {
          return;
        }
        var result = await this.$store.dispatch("screener/getStreams", {
          id: this.screener_id,
        });

        if (!result || result.streams != null) {
          this.processStreams(result.streams);
        }
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },

    processStreams(savedStreams) {
      var ObjDefaultStreams = Object.values(this.DEFINES.streams);
      var ObjSaveStreams = Object.values(savedStreams);
      ObjDefaultStreams.forEach((def) => {
        var isAvail = false;
        ObjSaveStreams.forEach((save) => {
          if (def.type == save.type) {
            isAvail = true;
            return;
          }
        });

        if (!isAvail) {
          savedStreams[def.type] = def;
        }
      });

      // Removing discontinued streams
      this.discontinuedStreams.forEach((streamKey) => {
        delete savedStreams[streamKey];
      });

      this.streams = savedStreams;
    },

    async saveStreams() {
      try {
        if (this.screener_id == undefined) {
          this.$store.dispatch("app/showMessage", {
            message: this.$t("screener.save.intr.screening_first"),
            color: "error",
          });
          return;
        }
        await this.$store.dispatch("screener/saveStreams", {
          id: this.screener_id,
          streams: this.streams,
        });
        this.$store.dispatch("app/showMessage", {
          message: this.$t("screener.save.success.message"),
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
        });
        this.configurationDialog.dialog = false;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },

    validateStream(stream) {
      var isValid = true,
        msg;
      switch (stream.type) {
        case this.DEFINES.ZoomMeeting:
          if (stream.meeting_number == null || stream.meeting_number == "") {
            isValid = false;
            msg = this.$t(
              "screener.save.form.stream.invalid_zoom_meeting_number"
            );
          }
          break;
        case this.DEFINES.VimeoLiveStream:
        case this.DEFINES.VimeoChatStream:
          if (stream.vimeo_live_id == null || stream.vimeo_live_id == "") {
            isValid = false;
            msg = this.$t("screener.save.form.stream.invalid_vimeo_id");
          }
          break;
        case this.DEFINES.LiveChat:
          if (stream.title == null || stream.title == "") {
            isValid = false;
            msg = this.$t("screener.save.form.stream.title_required");
          }
          break;
        case this.DEFINES.FacebookLiveStream:
          if (stream.content == null || stream.content == "") {
            isValid = false;
            msg = this.$t("screener.save.form.stream.invalid_fb_video_id");
          }
          break;
        case this.DEFINES.YoutubeLiveStream:
          if (stream.content == null || stream.content == "") {
            isValid = false;
            msg = this.$t("screener.save.form.stream.invalid_youtube_video_id");
          }
          break;
        case this.DEFINES.JitsiLiveStream:
          if (stream.meeting_url == null || stream.meeting_url == "") {
            isValid = false;
            msg = this.$t("screener.save.form.stream.invalid_meeting_url");
          }
          break;
        case this.DEFINES.WhereByMeeting:
          if (stream.meeting_url == null || stream.meeting_url == "") {
            isValid = false;
            msg = this.$t("screener.save.form.stream.invalid_meeting_url");
          }
          break;
        case this.DEFINES.LiveWebinar:
          if (stream.attendee_url == null || stream.attendee_url == "") {
            isValid = false;
            msg = this.$t("screener.save.form.stream.invalid_meeting_url");
          }
          break;
        case this.DEFINES.MediaStream:
          if (stream.selected_media_id == null || stream.streaming_url == "") {
            isValid = false;
            msg = this.$t("screener.save.form.stream.media_stream_not_configured");
          }
          break;
        case this.DEFINES.DailyCo:
          if (stream.meeting_url == null || stream.meeting_url == "") {
            isValid = false;
            msg = this.$t("screener.save.form.stream.invalid_meeting_url");
          }
          break;
        case this.DEFINES.iFrame:
          if (stream.source_code == null || stream.source_code == "") {
            isValid = false;
            msg = this.$t("screener.save.form.stream.source_code");
          }
          break;
        default:
          isValid = false;
          msg = this.$t("screener.save.form.stream.invalid_stream");
          break;
      }
      // if (!isValid) {
      //   this.$store.dispatch("app/showMessage", {
      //     message: msg,
      //     color: "error",
      //   });
      // }
      return isValid;
    },

    _removeForceFromOtherStream(stream) {
      for (var key in this.streams) {
        if (key != stream.type && this.streams[key].force) {
          this.streams[key].force = false;
          this.streams[key].active = false;
        }
      }
    },

    async broadcast(stream, force = false) {
      if (!this.validateStream(stream)) {
        return false;
      }
      try {
        if (this.$route.params.screener_id == undefined) {
          throw {
            message: "Please create the screener before enable the stream",
          };
        }

        if (!this.validateStream(stream)) {
          return false;
        }
        /**
         * due to force stream during new onboarding user
         * force only one stream
         */
        this._removeForceFromOtherStream(stream);
        stream.active = true;
        stream.force = force;
        // var result = await this.$store.dispatch("screener/broadcastStream", {
        //   id: this.screener_id,
        //   stream: stream,
        //   streams: this.streams,
        // });
        this.saveStreams();
        this.configurationDialog.dialog = false;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      } finally {
        this.dialog = false;
      }
    },

    async deactivate(stream) {
      try {
        stream.force = false;
        stream.active = false;
        this.saveStreams();
        this.configurationDialog.dialog = false;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },

    showPreview(stream) {
      if (
        stream.type != this.DEFINES.LiveChat &&
        !this.validateStream(stream)
      ) {
        return false;
      }
      var iframeSrc;
      this.is_live_chat_preview = false;
      switch (stream.type) {
        case this.DEFINES.ZoomMeeting:
          var password =
            stream.meeting_password != null ? stream.meeting_password : "";
          iframeSrc = getZoomUrl(
            this.screener_id,
            stream.meeting_number,
            password
          );
          break;

        case this.DEFINES.VimeoLiveStream:
          iframeSrc = getVimeoEmbedUrl(stream.vimeo_live_id);
          break;

        case this.DEFINES.VimeoChatStream:
          iframeSrc = getVimeoChatEmbedUrl(stream.vimeo_live_id);
          break;
        case this.DEFINES.LiveChat:
          this.is_live_chat_preview = true;
          break;

        case this.DEFINES.FacebookLiveStream:
          iframeSrc = getFacebookLiveEmbedUrl(stream.content);
          break;

        case this.DEFINES.YoutubeLiveStream:
          iframeSrc = getYoutubeLiveEmbedUrl(stream.content);
          break;
        case this.DEFINES.JitsiLiveStream:
          iframeSrc = stream.meeting_url;
          break;
      }
      if (iframeSrc) {
        this.previewStream = iframeSrc.replace(/\/+$/, "");
      }

      this.preview = true;
    },

    openConfigDialogWith(stream) {
      this.configurationDialog.dialog = true;
      this.currentConfiguringStream = stream;
    },

    isStreamConfigured(stream) {},
    async enforceMovie() {
      try {
        if (this.$route.params.screener_id == undefined) {
          throw {
            message: "Please create the screener before enable the stream",
          };
          return;
        }
        var stream = {
          type: "MovieStream",
        };
        /**
         * remove force from other stream if there any
         */
        this._removeForceFromOtherStream(stream);
        /**
         * broadcast
         */
        var result = await this.$store.dispatch("screener/broadcastStream", {
          id: this.screener_id,
          stream: stream,
          streams: this.streams,
        });
        this.$store.dispatch("app/showMessage", {
          message: this.$t("stream.enforce_movie.message_success"),
          color: "success",
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },

    enableLiveChat() {
      this.streams[this.DEFINES.LiveChat].active = true;
      this.saveStreams();
    },

    /**
     *===========================================================================================
     *                               FIREBASE REAL TIME DATA BINDING
     *===========================================================================================
     * Here we are binding realtime data of firebase screener-->streams so can listen all the
     * events real time.
     *
     */
    async bindScreenerWithFB() {
      let _this = this;
      this.firebase
        .database()
        .ref(`screener/${this.screener.id}`)
        .on("value", function (snapshot) {
          /**
           * Only override the required fields
           */
          let fb_screener = snapshot.val()
          _this.resolveFirebaseStreams(fb_screener.streams);
          /*
          * Override Firebase data to screener data so we have synchronized
          * data between multiple admins
          */
          if(fb_screener.streams){
            _this.streams = fb_screener.streams
          }

          /**
           * Bind last updated by
           */
          _this.lastUpdate.by   = fb_screener.last_updated_by
          _this.lastUpdate.time = fb_screener.updated_at

        });
    },

    async bindLiveCounterWithFBase(screenerId) {
      let _this = this;
      this.firebase
        .database()
        .ref(`/live_counter/${this.screener.id}/counter`)
        .on("value", function (snapshot) {
          _this.liveUsers = snapshot.val();
        });
    },

    bindScreenerNotificationsWithFB() {
      let _this = this;
      let currentTimeStamp = Math.round(Date.now()/1000);
      this.firebase.database().ref(`screener_notifications/${this.screener.id}/`).on('child_added',function(snapshot) {
       if(snapshot.key > currentTimeStamp){
         let payload = snapshot.val();
         _this.snackbar.isVisible = true;
         _this.snackbar.message = payload.message;
       }
      })
    },

    resolveFirebaseStreams(streams) {
      this.resolveFirebaseForcedStreams(streams);
      this.resolveFirebaseActiveStreams(streams);
    },

    resolveFirebaseForcedStreams(streams) {
      let forced_stream = null;
      for (var key in streams) {
        if (streams[key].force && streams[key].active) {
          forced_stream = this.streams[key];
        }
      }
      this.fb_forced_stream = forced_stream
        ? Object.assign({}, forced_stream)
        : null;
      return;
    },

    resolveFirebaseActiveStreams(streams) {
      let active_streams = [];
      for (var key in streams) {
        if (streams[key].active && !streams[key].force) {
          active_streams.push(streams[key]);
        }
      }
      this.fb_active_streams = active_streams
        ? Object.assign([], active_streams)
        : [];
      return;
    },
  },
};
</script>
<style scoped>
.blink {
  animation: blink-animation 1s steps(5, start) infinite;
  -webkit-animation: blink-animation 1s steps(5, start) infinite;
}
@keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
@-webkit-keyframes blink-animation {
  to {
    visibility: hidden;
  }
}
.preview-section {
  border: 2px solid grey
}
</style>
